
module.exports = function (paths) {
    const FURTHER_REF = paths.FURTHER_REF
    return {
        test: /\.(json5|json)$/,
        loader: FURTHER_REF + 'json5-loader',
        exclude: /node_modules/
    }
}



// WEBPACK FOOTER //
// ./src/technologies/json.js